import { render, staticRenderFns } from "./ModalMicrodataApi.vue?vue&type=template&id=294675b6&scoped=true&"
import script from "./ModalMicrodataApi.vue?vue&type=script&lang=js&"
export * from "./ModalMicrodataApi.vue?vue&type=script&lang=js&"
import style0 from "./ModalMicrodataApi.vue?vue&type=style&index=0&id=294675b6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294675b6",
  null
  
)

export default component.exports